import { defineComponent as _defineComponent } from 'vue'
import { Faqs } from '~/data/plans_faqs';
import Faq from '~/components/plans/Faq.vue';

interface Props {
  faqsByVariant: Faqs[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FaqSection',
  props: {
    faqsByVariant: null
  },
  setup(__props: any) {



return { __sfc: true,Faq }
}

})